// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "9f428070131860829e5a" + ".chunk.js";
};